import {useRef, useSyncExternalStore} from 'react';
import {createDirectoryManagement} from './directoryManagement.js';

export function useDirectoryManagement(api, refresh) {
  const latest = useRef(); latest.current = {api, refresh};
  const manager = useRef();
  if (!manager.current) manager.current = createDirectoryManagement({api: (...args) => latest.current.api(...args), refresh: () => latest.current.refresh()});
  const operation = useSyncExternalStore(manager.current.subscribe, manager.current.getSnapshot);
  return {manager: manager.current, operation};
}
